import { useNavigate } from "react-router-dom";

export default function AdminPageHeader({ title, backTo, subtitle }) {

  const navigate = useNavigate();

  return (
    <div style={wrapperStyle}>

      {/* 🔙 BACK */}
      {backTo && (
        <button
          onClick={() => navigate(backTo)}
          style={backBtnStyle}
        >
          ← Volver
        </button>
      )}

      {/* 🧠 TÍTULO */}
      <div>
        <h2 style={titleStyle}>{title}</h2>

        {subtitle && (
          <p style={subtitleStyle}>{subtitle}</p>
        )}
      </div>

    </div>
  );
}

/* ===== STYLES ===== */

const wrapperStyle = {
  marginBottom: 20
};

const backBtnStyle = {
  marginBottom: 8,
  background: "transparent",
  border: "none",
  color: "#2c3b51",
  fontWeight: 600,
  cursor: "pointer"
};

const titleStyle = {
  margin: 0
};

const subtitleStyle = {
  marginTop: 4,
  color: "#6b7280"
};